{
  "about": "Single source of colour, type, space, radius and motion for web (CSS variables) and Android (Kotlin). Edit here, then `npm run tokens`. Every text colour meets WCAG AA (4.5:1) on surface and raised in its theme.",
  "palettes": {
    "sage": {
      "label": "Sage",
      "blurb": "Warm, soft green",
      "dark": {
        "bg": "#131311",
        "nav": "#0f0f0d",
        "surface": "#171715",
        "raised": "#1f1f1c",
        "overlay": "#1b1b18",
        "segOn": "#2c2c28",
        "hover": "#f0ece00b",
        "press": "#f0ece016",
        "sel": "#f0ece012",
        "line": "#252520",
        "line2": "#31312b",
        "line3": "#41413a",
        "text": "#dfddd6",
        "text2": "#b0aea5",
        "text3": "#8f8d84",
        "textRead": "#8b8981",
        "prose": "#d2d0c9",
        "accent": "#93bfa3",
        "accentHi": "#a8d0b6",
        "accentInk": "#10201a",
        "accentText": "#9cc8ab",
        "accentSoft": "#93bfa321",
        "accentLine": "#93bfa373",
        "link": "#a3cdb1",
        "linkLine": "#a3cdb166",
        "focus": "#9cc8ab",
        "warn": "#e2b45c",
        "warnSoft": "#e2b45c1a",
        "danger": "#ef6b63",
        "dangerSoft": "#ef6b631c",
        "dangerInk": "#171715",
        "scrim": "#0606059e",
        "imgBg": "#1d1d1a",
        "comicBg": "#f4f3ef",
        "tipBg": "#ecebe6",
        "tipText": "#171715",
        "toastBg": "#ecebe6",
        "toastText": "#171715",
        "toastAccent": "#2f6b4c",
        "selection": "#93bfa34d",
        "skeleton": "#f0ece00d",
        "skeletonHi": "#f0ece01a"
      },
      "light": {
        "bg": "#f6f4ef",
        "nav": "#efece5",
        "surface": "#fbfaf7",
        "raised": "#ebe8e1",
        "overlay": "#fdfcfa",
        "segOn": "#fdfcfa",
        "hover": "#2824180b",
        "press": "#28241816",
        "sel": "#2824180f",
        "line": "#e4e0d7",
        "line2": "#d6d1c6",
        "line3": "#c2bcb0",
        "text": "#1c1b17",
        "text2": "#4f4c44",
        "text3": "#66635a",
        "textRead": "#6a675f",
        "prose": "#24221d",
        "accent": "#3a7556",
        "accentHi": "#30654a",
        "accentInk": "#ffffff",
        "accentText": "#346b4f",
        "accentSoft": "#3a75561a",
        "accentLine": "#3a755666",
        "link": "#346b4f",
        "linkLine": "#346b4f5c",
        "focus": "#3a7556",
        "warn": "#905d04",
        "warnSoft": "#b078101a",
        "danger": "#c1322a",
        "dangerSoft": "#c4352d14",
        "dangerInk": "#ffffff",
        "scrim": "#1c1a1447",
        "imgBg": "#ebe8e1",
        "comicBg": "#ffffff",
        "tipBg": "#1f1e1a",
        "tipText": "#f4f2ec",
        "toastBg": "#1f1e1a",
        "toastText": "#f4f2ec",
        "toastAccent": "#9cc8ab",
        "selection": "#3a755633",
        "skeleton": "#2824180e",
        "skeletonHi": "#2824181a"
      }
    },
    "slate": {
      "label": "Slate",
      "blurb": "Cool, quiet blue",
      "dark": {
        "bg": "#101215",
        "nav": "#0c0e10",
        "surface": "#15171b",
        "raised": "#1c1f24",
        "overlay": "#181b20",
        "segOn": "#2a2e35",
        "hover": "#d6e2f40b",
        "press": "#d6e2f416",
        "sel": "#d6e2f412",
        "line": "#212429",
        "line2": "#2d3138",
        "line3": "#3b4048",
        "text": "#dcdfe3",
        "text2": "#a8aeb6",
        "text3": "#828891",
        "textRead": "#838890",
        "prose": "#cbced3",
        "accent": "#89a4de",
        "accentHi": "#9db7ef",
        "accentInk": "#111a2d",
        "accentText": "#9eb7eb",
        "accentSoft": "#89a4de24",
        "accentLine": "#89a4de73",
        "link": "#9eb7eb",
        "linkLine": "#9eb7eb66",
        "focus": "#9eb7eb",
        "warn": "#e2b45c",
        "warnSoft": "#e2b45c1a",
        "danger": "#ef6b63",
        "dangerSoft": "#ef6b631c",
        "dangerInk": "#15171b",
        "scrim": "#0506089e",
        "imgBg": "#1a1d21",
        "comicBg": "#f3f3f1",
        "tipBg": "#e8eaed",
        "tipText": "#14171b",
        "toastBg": "#e8eaed",
        "toastText": "#14171b",
        "toastAccent": "#3c5aa1",
        "selection": "#89a4de52",
        "skeleton": "#d6e2f40d",
        "skeletonHi": "#d6e2f41a"
      },
      "light": {
        "bg": "#f6f7f8",
        "nav": "#eef0f2",
        "surface": "#ffffff",
        "raised": "#eaedf0",
        "overlay": "#ffffff",
        "segOn": "#ffffff",
        "hover": "#121a260b",
        "press": "#121a2616",
        "sel": "#121a260f",
        "line": "#e3e6ea",
        "line2": "#d4d9df",
        "line3": "#bfc5cd",
        "text": "#14171b",
        "text2": "#4a515a",
        "text3": "#626973",
        "textRead": "#636972",
        "prose": "#1d2126",
        "accent": "#4160a7",
        "accentHi": "#345197",
        "accentInk": "#ffffff",
        "accentText": "#3c5aa1",
        "accentSoft": "#4160a717",
        "accentLine": "#4160a766",
        "link": "#3c5aa1",
        "linkLine": "#3c5aa15c",
        "focus": "#4160a7",
        "warn": "#925f06",
        "warnSoft": "#b078101a",
        "danger": "#c3342c",
        "dangerSoft": "#c4352d14",
        "dangerInk": "#ffffff",
        "scrim": "#14181e47",
        "imgBg": "#eceef1",
        "comicBg": "#ffffff",
        "tipBg": "#1b1e23",
        "tipText": "#f1f3f5",
        "toastBg": "#1b1e23",
        "toastText": "#f1f3f5",
        "toastAccent": "#9eb7eb",
        "selection": "#4160a733",
        "skeleton": "#121a260e",
        "skeletonHi": "#121a261a"
      }
    }
  },
  "black": {
    "about": "Pure black (OLED) overrides applied on top of either palette in dark mode. Text is dimmed slightly to avoid halation on black.",
    "bg": "#000000",
    "nav": "#000000",
    "surface": "#000000",
    "raised": "#141414",
    "overlay": "#101010",
    "segOn": "#262626",
    "line": "#1c1c1c",
    "line2": "#272727",
    "line3": "#363636",
    "text": "#dbdbd7",
    "text2": "#a9a8a3",
    "text3": "#8a8984",
    "textRead": "#7e7e79",
    "prose": "#cac9c4",
    "imgBg": "#0e0e0e"
  },
  "type": {
    "ui": "Geist",
    "read": "Newsreader",
    "uiSizes": {
      "t11": 11,
      "t12": 12,
      "t13": 13,
      "t14": 14,
      "t16": 16,
      "t20": 20,
      "t24": 24,
      "t28": 28,
      "t15": 15
    },
    "readSizes": [
      16,
      17.5,
      19,
      20.5,
      22.5
    ],
    "readSizeDefault": 2,
    "measure": [
      58,
      66,
      74,
      84,
      96
    ],
    "measureDefault": 1,
    "lineHeight": {
      "serif": 1.6,
      "sans": 1.62
    },
    "headline": {
      "web": 28,
      "phone": 24
    },
    "nativeStyles": {
      "t11": {
        "family": "ui",
        "size": "t11",
        "lineHeight": 14
      },
      "t12": {
        "family": "ui",
        "size": "t12",
        "lineHeight": 16
      },
      "t13": {
        "family": "ui",
        "size": "t13",
        "lineHeight": 18
      },
      "t14": {
        "family": "ui",
        "size": "t14",
        "lineHeight": 20
      },
      "t16": {
        "family": "ui",
        "size": "t16",
        "lineHeight": 21.6
      },
      "title": {
        "family": "ui",
        "size": "t16",
        "lineHeight": 21.6,
        "weight": 550,
        "tracking": -0.08
      },
      "brand": {
        "family": "read",
        "size": "t20",
        "weight": 600,
        "tracking": -0.4
      }
    }
  },
  "space": {
    "s1": 4,
    "s2": 8,
    "s3": 12,
    "s4": 16,
    "s5": 20,
    "s6": 24,
    "s8": 32,
    "s10": 40,
    "s12": 48,
    "s16": 64,
    "sHalf": 2,
    "sOneHalf": 6,
    "sTwoHalf": 10,
    "sThreeHalf": 14,
    "sFourHalf": 18,
    "sNine": 36,
    "readerBottom": 96,
    "sControlInset": 9
  },
  "radius": {
    "sm": 6,
    "md": 10,
    "lg": 16,
    "xs": 4,
    "control": 8,
    "swatch": 9,
    "panel": 12,
    "logo": 15,
    "pill": 20,
    "toast": 24,
    "transition": 28,
    "icon": 3
  },
  "motion": {
    "d1": 120,
    "d2": 180,
    "d3": 240,
    "settle": 220,
    "close": 170
  },
  "readerColors": {
    "compareLine": "#ffffff",
    "compareShadow": "rgba(0,0,0,.25)",
    "compareHandleShadow": "rgba(0,0,0,.35)",
    "pros": "#3f9a5a",
    "cons": "#cf4b43",
    "mediaBg": "#000000",
    "mediaPlay": "rgba(0,0,0,.7)",
    "mediaPlayHover": "rgba(0,0,0,.88)",
    "mediaInk": "#ffffff",
    "lightboxText": "#e8e8e8",
    "lightboxMuted": "#9a9a9a",
    "lightboxButton": "rgba(255,255,255,.12)",
    "lightboxGradient": "rgba(0,0,0,.72)",
    "chartBg": "#ffffff"
  }
}
